var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "associated-product-wrapper" },
    [
      _c("transition", { attrs: { name: "component-fade", mode: "out-in" } }, [
        _vm.ready && _vm.product != null
          ? _c("div", { key: "ready", staticClass: "associated-product" }, [
              _c("div", { staticClass: "left-wrapper" }, [
                _c("div", { staticClass: "thumbnail" }, [
                  _c("img", {
                    staticClass: "lazyload",
                    attrs: { "data-src": _vm.firstImage, alt: _vm.product.name }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "copy" }, [
                  _c("div", { staticClass: "name-link" }, [
                    _c("h3", {
                      domProps: { innerHTML: _vm._s(_vm.product.name) }
                    }),
                    _vm._v(" "),
                    _vm.product.variants.length > 1
                      ? _c(
                          "a",
                          { attrs: { href: "/product/" + _vm.product.slug } },
                          [_vm._v("Bekijk product")]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm.product.variants.length === 1
                    ? _c("div", { staticClass: "pricing" }, [
                        _c("span", { staticClass: "price" }, [
                          _vm._v(
                            "€ " +
                              _vm._s(
                                _vm.$store.getters["pricesIncludingVat"]
                                  ? _vm.product.variants[0].price_vat_incl
                                  : _vm.product.variants[0].price
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _vm.$store.getters["pricesIncludingVat"]
                          ? _c("span", { staticClass: "text" }, [
                              _vm._v("Inclusief BTW")
                            ])
                          : _c("span", { staticClass: "text" }, [
                              _vm._v("Exclusief BTW")
                            ])
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _vm.product.variants.length === 1
                ? _c("div", { staticClass: "right-wrapper" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.amount,
                          expression: "amount"
                        }
                      ],
                      staticClass: "last:mr-0 mr-8",
                      attrs: { type: "number" },
                      domProps: { value: _vm.amount },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.amount = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("button", {
                      staticClass:
                        "btn btn-green btn-sm btn-rounded last:mr-0 mr-8",
                      domProps: { innerHTML: _vm._s(_vm.svg("plus")) },
                      on: { click: _vm.addToCart }
                    })
                  ])
                : _vm._e()
            ])
          : _c(
              "div",
              {
                key: "loading",
                staticClass: "flex items-center justify-center flex-1"
              },
              [_c("spinner")],
              1
            )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }